import React from "react";
import { Box, Button, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"; // Import the icon
import { openApp } from "../../utils/function";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
export default function MobileCards({ title, subtitle, image, url, appName }) {
  const token = JSON.parse(localStorage.getItem("okta-token-storage"));
  const navigate = useNavigate();
  const { External } = useSelector((store) => store.config); // Get the authentication state
  return (
    <Box
      sx={{
        display: "flex",
        padding: "16px",
        alignItems: "flex-start",
        gap: "16px",
        flex: "1 0 0",
        alignSelf: "stretch",
        flexDirection: "column",
        borderRadius: "16px",
        backgroundColor: "#FFF",
        boxShadow: "0px 0px 24px 0px rgba(0, 92, 188, 0.08)",
      }}
    >
      <Box
        component="img"
        src={image}
        alt="logo"
        sx={{
          width: "100%",
          height: "140px",
          objectFit: "cover",
          borderRadius: "8px",
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: "8px",
          flex: "1 0 0",
        }}
      >
        <Typography
          sx={{
            color: "#27251F",
            fontFamily: "Inter, sans-serif",
            fontSize: "18px",
            fontWeight: 700,
            lineHeight: "28px",
            fontStyle: "normal",
          }}
        >
          {title}
        </Typography>

        <Button
          sx={{
            display: "flex",
            flexDirection: "row", // Ensure icon and text are in a row
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "36px",
            borderRadius: "24px",
            backgroundColor: "#005CBC",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#004B9A",
            },
          }}
          onClick={() => openApp(token, appName, url, External, navigate)}
          endIcon={<ArrowForwardIcon sx={{ fontSize: "16px" }} />} // Adjust icon size
        >
          <Typography
            sx={{
              color: "#FFF",
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "133%",
              display: "inline", // Keep text inline with the icon
            }}
          >
            Open App
          </Typography>
        </Button>
      </Box>
    </Box>
  );
}
